module.exports = __webpack_public_path__ + "static/media/ball_3_5.f8b937fa.mp3";